import axios from 'axios';
import AuthService from './auth-header';

let API_URL = ''
    if (process.env.NODE_ENV === "production") {
        API_URL = 'https://ats.sattvahuman.in/api/'
    } else {
        API_URL = 'http://192.168.0.30:5000/api/'
    }

class EnhancedInvoiceExportService {
    // Export reconciliation data
    async exportReconciliationData(filters, format = 'excel') {
        try {
            const params = {
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/reconciliation', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export compliance data
    async exportComplianceData(filters, format = 'excel') {
        try {
            const params = {
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/compliance', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export financial data
    async exportFinancialData(filters, format = 'excel') {
        try {
            const params = {
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/financial', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export tax data
    async exportTaxData(filters, format = 'excel') {
        try {
            const params = {
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/tax', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export audit trail
    async exportAuditTrail(invoiceId, format = 'excel') {
        try {
            const params = { format };
            const res = await axios.get(API_URL + 'invoice/' + invoiceId + '/export/audit-trail', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export booking status report
    async exportBookingStatusReport(filters, format = 'excel') {
        try {
            const params = {
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/booking-status', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Export custom report
    async exportCustomReport(reportType, filters, format = 'excel') {
        try {
            const params = {
                reportType,
                format,
                ...filters
            };
            const res = await axios.get(API_URL + 'invoice/export/custom', {
                params,
                headers: AuthService.authHeader(),
                responseType: format === 'pdf' || format === 'excel' ? 'blob' : 'json'
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Get export templates
    async getExportTemplates() {
        try {
            const res = await axios.get(API_URL + 'invoice/export/templates', {
                headers: AuthService.authHeader()
            });
            return res.data;
        } catch (err) {
            console.log(err.response);
            return err.response;
        }
    }

    // Download exported file
    downloadFile(blob, filename) {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
}

export default new EnhancedInvoiceExportService();
